import { API_URL } from "config";
import Http from "util/https";
import { downloadFromUrl } from "../utils/common";

/**
 * ダウンロードするURLを取得
 * @param orderNumber 注文作成番号。編集モードの場合は同じ注文作成番号を持った実データが入ったものを持ってくる。 => downloadOrderAskCsv.tsで行うので使用しない
 */
export default async function downloadOrderSampleCsv(orderNumber?: string) {
  console.log(`downloadOrderSampleCsv`);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/product/sample/download`;
  const res = await http.get(url, {});
  console.log(res);
  // const res: {data: {url: string}} = {data: {url: 'https://sample-videos.com/csv/Sample-Spreadsheet-10-rows.csv'}}

  downloadFromUrl(res.data.url, orderNumber ? '注文データ' : '注文サンプル');

  return res.data;
}